import { KIND } from '../../constants/badge'
import { CURRENCY_CODE } from '../../constants/payments'
import { getMediaKind } from '../../utils/auto/media'
import { getAutoPrice, getOrderPrice } from '../../utils/auto/price'
import { getSelectedVasPrices } from '../../utils/auto/vas'
import { isNlt } from '../../utils/nltUtils'

const ENHANCED_ECOMMERCE_EVENTS = {
  ADD: 'eec.add',
  CHECKOUT: 'eec.checkout',
  CHECKOUT_OPTION: 'eec.checkout_option',
  PURCHASE: 'eec.purchase',
}

const NO_SERVICE_SELECTED = 'service_no_service'

export const ENHANCED_ECOMMERCE_LISTING_KEY = 'eec_listing'

export class EnhancedEcommerceMapper {
  static mapAdd(auto, list = null) {
    auto.quantity = 1

    return {
      ecommerce: {
        add: {
          actionField: {
            list,
          },
          products: [auto],
        },
      },
      event: ENHANCED_ECOMMERCE_EVENTS.ADD,
    }
  }

  static mapCheckout(auto, step) {
    auto.quantity = 1

    return {
      ecommerce: {
        checkout: {
          actionField: {
            step,
          },
          products: [auto],
        },
      },
      event: ENHANCED_ECOMMERCE_EVENTS.CHECKOUT,
    }
  }

  static mapCheckoutOption(step, option) {
    return {
      ecommerce: {
        checkout_option: {
          actionField: {
            step,
            option,
          },
        },
      },
      event: ENHANCED_ECOMMERCE_EVENTS.CHECKOUT_OPTION,
    }
  }

  static mapOrder({ product, ordine, nlt, logistica }) {
    return {
      coupon:
        (nlt && ordine?.codiceCoupon) || ordine?.codice_preventivo || null,
      id: ordine?.id_ordine,
      'property-transfer': ordine?.auto_costo_passaggio_proprieta || 0,
      revenue: getOrderPrice(product?.linea_prodotto, ordine, nlt),
      shipping:
        logistica?.centro_convenzionato?.prezzo ||
        logistica?.centro_convenzionato?.prezzo_listino ||
        null,
      ...getSelectedVasPrices(product, ordine, nlt),
    }
  }

  static mapProduct({ product, ordine, nlt }) {
    return {
      availability: product.disponibilita,
      brand: product.marca,
      category: product.tipologia,
      channel: product.linea_prodotto,
      colour: product.colore_ext_femminile,
      'fuel-type': product.alimentazione,
      gearbox: product.cambio,
      id: product.id_auto,
      'image-type': getMediaKind(product.media?.basePath, product.id_auto),
      km: product.km,
      model: product.modello,
      name: `${product.marca} ${product.modello}`,
      power: product.motorizzazione,
      price: isNlt(product.linea_prodotto)
        ? getOrderPrice(product.linea_prodotto, ordine, nlt)
        : getAutoPrice(product) ||
          getOrderPrice(product.linea_prodotto, ordine, nlt),
      promotion:
        product.badges?.find(badge => KIND.SECONDARY === badge.kind)?.label ||
        null,
      type: product.tipo_veicolo,
      version: product.allestimento_breve,
      year: product.anno,
    }
  }

  static mapPurchase(order, auto) {
    auto.quantity = 1

    return {
      ecommerce: {
        currencyCode: CURRENCY_CODE,
        purchase: {
          actionField: { ...order },
          products: [auto],
        },
      },
      event: ENHANCED_ECOMMERCE_EVENTS.PURCHASE,
    }
  }

  static mapSelectedVas({ product, ordine, nlt }) {
    const option = Object.keys(getSelectedVasPrices(product, ordine, nlt))

    if (!option || option.length === 0) {
      return NO_SERVICE_SELECTED
    }

    return option
  }
}
